import { QuestionPlanDefaultDiscount as Question } from "@/components/features/items/edit/plan/_shared/ui/components/connection/discount-connection/default-discount-id";

import { usePlanAvailableDiscountIDs } from "./hooks";

export const QuestionPlanDefaultDiscount = () => {
	const { defaultDiscountID, onSetDefaultDiscountID, discountNameAndIDOptions } = usePlanAvailableDiscountIDs();

	return (
		<Question
			defaultDiscountID={defaultDiscountID}
			onSetDefaultDiscountID={onSetDefaultDiscountID}
			discountNameAndIDOptions={discountNameAndIDOptions}
		/>
	);
};

QuestionPlanDefaultDiscount.displayName = "QuestionPlanDefaultDiscount";
